module.exports = __webpack_public_path__ + "img/math-multiplication.6bc9d133.svg";